import {periodicityOptions} from './../constants/periodicity-constants';
import {paymentMethods} from './../constants/payment-constants';

export class MemberReceiptsStatistics {
    constructor(
        uuid,
        fullName,
        code,
        createdAt,
        paymentMethod,
        periodicity,
        feeAmount,
        numReceipts,
        numReceiptsTreated,
        numReceiptsCharged,
        numReceiptsCanceled,
        lastReceiptChargedDate
    ) {
        this.uuid = uuid;
        this.fullName = fullName;
        this.code = code;
        this.createdAt = createdAt;
        this.paymentMethod = paymentMethod;
        this.periodicity = periodicity;
        this.feeAmount = feeAmount;
        this.numReceipts = numReceipts;
        this.numReceiptsTreated = numReceiptsTreated;
        this.numReceiptsCharged = numReceiptsCharged;
        this.numReceiptsCanceled = numReceiptsCanceled;
        this.lastReceiptChargedDate = lastReceiptChargedDate;
    }

    getPeriodicityName() {
        let periodicity = periodicityOptions.find(periodicity => (periodicity.key === this.periodicity));
        return !!periodicity ? periodicity.value : null;
    }

    getPaymentMethodName() {
        let paymentMethod = paymentMethods.find(paymentMethod => (paymentMethod.key === this.paymentMethod));
        return !!paymentMethod ? paymentMethod.value : null;
    }
}